import * as importService from '@core/api/importService';
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useImport() {
  const queryClient = useQueryClient();

  const importProductsMutation = useMutation({
    mutationFn: importService.importProducts,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["Products"] });
    },
  });

  return {
    importProducts: importProductsMutation.mutate,
    importProductsLoading: importProductsMutation.isPending,
  };
}

export const useImportPackages = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: importService.importPackages,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["packagesImported"],
      });
    },
  });
};
